module.exports = __webpack_public_path__ + "img/mozambique.ef1f9282.svg";